<script setup lang="ts">
import { useHomeSections } from '~/composables/apostatudo/use-home-sections';

const title = computed(() => {
  return `${appName()} 🍀 Cassino e Apostas Online | Apostas Esportivas`;
});

const description = computed(() => {
  return `${appName()} é o melhor site de cassino 🎰 e apostas esportivas ⚽ com diversas opções de esportes para apostar, jogos de cassino para jogar e promoções exclusivas 🎁. Com uma plataforma intuitiva e segura, oferecemos milhares de jogos de cassino, jogos de esportes e suporte ao cliente 24/7.`;
});

useSeo({
  title: title.value,
  description: description.value,
});

const { isHomeAsSportbookEnabled } = useFeatureFlagsNew();

const { fetchHomeSections, hasItems, hasCategories } = useHomeSections();

const isHomeReady = computed(() => hasItems.value || hasCategories.value);
const apiCheckDone = ref(false);

onMounted(async () => {
  if (isHomeAsSportbookEnabled.value) {
    return;
  }

  await fetchHomeSections();
  apiCheckDone.value = true;
});
</script>

<template>
  <template v-if="isHomeAsSportbookEnabled">
    <PagesSports />
  </template>

  <template v-else>
    <PagesHomeSkeleton v-if="!apiCheckDone" />

    <PagesHomeV2 v-else-if="isHomeReady" />

    <PagesHome v-else />

    <ApTitleHome />
  </template>
</template>
